export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Bank of Baroda Car Loan EMI Calculator: Drive Your Dream Car with Smart Planning",
    subHeading:
      "Buying a car is an exciting milestone, but understanding and managing your car loan EMI is crucial to ensuring a stress-free financial journey. With Minemi’s Car Loan EMI Calculator, you can plan your monthly payments, compare loan options, and make informed decisions that suit your budget.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
